import { normalizeStringArrayByItemOptionsKeepEmpty } from '../shared/valueUtils';

import type { IFilterItemConfig } from '@intelligence/v3/filterCore/types';

export const normalizeMultipleSelectValueByItem = (item: IFilterItemConfig, value: unknown): string[] => {
  return normalizeStringArrayByItemOptionsKeepEmpty(item, value);
};
